import { History } from 'history'

/**
 * Get chat context state safely
 */
export const getChatContextState = (history: History<unknown>) => {
  try {
    const offsetInMinutes = new Date().getTimezoneOffset()
    const offsetInHours = -offsetInMinutes / 60
    const timezoneOffsetString = offsetInHours > 0 ? `+${offsetInHours}` : offsetInHours

    // Get messages not yet shared with voice context from Redux store
    const chatDrawerState = window.reduxStore?.getState()?.chatDrawer
    const chatUnsharedQueue =
      chatDrawerState?.messages?.filter((msg) => !msg.sharedWithContexts.includes('voice')) || []

    // Format unshared messages for context
    const unsharedContext =
      chatUnsharedQueue.length > 0
        ? {
            previous_conversation: chatUnsharedQueue.map((msg) => ({
              role: msg.direction === 'send' ? 'user' : 'assistant',
              content: msg.content,
              sharedWithContexts: msg.sharedWithContexts,
              buttonActions: [],
            })),
          }
        : {}

    return {
      pathname: history?.location?.pathname || '',
      timezone_offset_hours: timezoneOffsetString,
      ...unsharedContext,
    }
  } catch (error) {
    console.error('Error getting chat context state:', error)
    return {}
  }
}

